import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "components/Common/Breadcrumb";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import ptBrLocale from "@fullcalendar/core/locales/pt-br";

import meetingService from "services/MeetingService";
import permissionsService from "services/permissionsService";

import "./calendarStyles.css"; // Importa o arquivo CSS customizado

const MeetingsCalendar = () => {
	const [meetings, setMeetings] = useState([]);
	const [temPermissaoVisualizar, setTemPermissaoVisualizar] = useState(false);
	const [temPermissaoAdicionar, setTemPermissaoAdicionar] = useState(false);
	const [temPermissaoEditar, setTemPermissaoEditar] = useState(false);
	const [temPermissaoExcluir, setTemPermissaoExcluir] = useState(false);

	const navigate = useNavigate();

	document.title = "Senda | Agenda";

	useEffect(() => {
		const getMeetings = async () => {
			try {
				const response = await meetingService.getAll();
				const eventsFormatted = response.map((mtg) => ({
					id: mtg.id,
					title: mtg.title,
					start: mtg.date_start,
					end: mtg.date_end,
					allDay: false,
				}));
				setMeetings(eventsFormatted);
			} catch (error) {
				console.error("Erro ao buscar meetings:", error);
			}
		};

		const getPermissions = async () => {
			try {
				const response = await permissionsService.getPermissions();
				response.forEach((permission) => {
					if (permission.role === "meetingIndex")
						setTemPermissaoVisualizar(true);
					if (permission.role === "meetingCreate")
						setTemPermissaoAdicionar(true);
					if (permission.role === "meetingUpdate")
						setTemPermissaoEditar(true);
					if (permission.role === "meetingDelete")
						setTemPermissaoExcluir(true);
				});
			} catch (error) {
				console.error(error);
			}
		};

		getPermissions();
		getMeetings();
	}, []);

	const handleDateClick = (arg) => {
		if (temPermissaoAdicionar) {
			navigate(`/agenda/form?date=${arg.dateStr}`);
		}
	};

	const handleEventClick = (info) => {
		const eventId = info.event.id;
		if (temPermissaoEditar) {
			navigate(`/agenda/form/${eventId}`);
		}
	};

	if (!temPermissaoVisualizar) return null;

	return (
		<div className="page-content">
			{temPermissaoAdicionar && (
				<Breadcrumbs
					botaoLink={"/agenda/form"}
					botao={"Adicionar Reunião"}
					title="Agenda"
				/>
			)}

			<div
				className="container-fluid"
				style={{
					backgroundColor: "white",
					padding: 20,
					borderRadius: 10,
					marginTop: 25,
				}}
			>
				<FullCalendar
					plugins={[
						dayGridPlugin,
						timeGridPlugin,
						interactionPlugin,
						listPlugin,
					]}
					initialView="dayGridMonth"
					headerToolbar={{
						left: "prev,next today",
						center: "title",
						right: "dayGridMonth,timeGridWeek,timeGridDay",
					}}
					views={{
						dayGridMonth: { buttonText: "Mês" },
						timeGridWeek: { buttonText: "Semana" },
						timeGridDay: { buttonText: "Dia" },
					}}
					locale={ptBrLocale}
					events={meetings}
					dateClick={handleDateClick}
					eventClick={handleEventClick}
				/>
			</div>
		</div>
	);
};

export default withTranslation()(MeetingsCalendar);
